import { useCallback, useEffect, useState } from 'react';

import { reportError } from 'helpers/error-logging';

import { PAGE_SIZE } from './SkuPayoutReports.constants';
import { fetchPayouts, filterCompletedItemization } from './SkuPayoutReports.helpers';

const INITIAL_RESULT = { payouts: [], count: 0 };

export default function useSkuPayoutsList({ venueId, onLoadError }) {
  const [payouts, setPayouts] = useState(INITIAL_RESULT.payouts);
  const [count, setCount] = useState(INITIAL_RESULT.count);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setPage(1);
  }, [venueId]);

  useEffect(() => {
    if (!venueId) {
      return undefined;
    }

    let isActive = true;
    setIsLoading(true);

    const load = async () => {
      try {
        const response = await fetchPayouts({ venueId, page: page - 1, perPage: PAGE_SIZE });
        if (!isActive) return;
        setPayouts(filterCompletedItemization(response?.payouts || []));
        setCount(response?.pageInfo?.totalItems || 0);
      } catch (error) {
        if (!isActive) return;
        reportError('Error fetching SKU payouts', error);
        onLoadError();
        setPayouts(INITIAL_RESULT.payouts);
        setCount(INITIAL_RESULT.count);
      } finally {
        if (isActive) setIsLoading(false);
      }
    };

    load();

    return () => {
      isActive = false;
    };
  }, [venueId, page, onLoadError]);

  const changePage = useCallback(nextPage => {
    setPage(nextPage);
  }, []);

  return { payouts, count, page, changePage, isLoading };
}
